import { render, staticRenderFns } from "./RankingsTable.vue?vue&type=template&id=01ab2d8e&"
import script from "./RankingsTable.vue?vue&type=script&lang=js&"
export * from "./RankingsTable.vue?vue&type=script&lang=js&"
import style0 from "./RankingsTable.vue?vue&type=style&index=0&id=01ab2d8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports